import { useSiteSettings } from '../hooks/useContent';
import LegalPage from '../components/LegalPage';
import { DEFAULT_PRIVACY_HTML } from '../utils/siteSettingsJson';

export default function Privacy() {
  const { settings, loading } = useSiteSettings();
  const title = String(settings.privacy_page_title || '').trim() || 'Privacy Policy';
  const html = String(settings.privacy_page_html || '').trim() || DEFAULT_PRIVACY_HTML;
  const publicBase =
    String(settings.site_public_url || '').replace(/\/$/, '') ||
    (typeof window !== 'undefined' ? window.location.origin : '');

  return (
    <LegalPage
      pageTitle={title}
      contentHtml={html}
      seoPath="/privacy"
      brand={settings.site_brand_name || 'Invincible NGO'}
      metaDescription={settings.site_meta_description}
      publicBase={publicBase}
      loading={loading}
    />
  );
}
